export const infoList = [
  {
    id: '1',
    text: '<strong>Consulte gratuitamente</strong> seu CPF',
  },
  {
    id: '2',
    text: '<strong>Selecione as dívidas</strong> e a forma de pagamento',
  },
  {
    id: '3',
    text: '<strong>Pague</strong> com Pix ou via boleto e pronto ;)',
  },
]

export const testimonials = [
  {
    id: '1',
    date: '2022-11-01 00:00',
    name: 'Ana',
    content:
      'Recomendo contatar o Grupo Recovery se tiverem dúvidas ou precisarem de ajuda. Tive um suporte incrível e resolvi meu problema. Melhor profissionalismo que vi em bastante tempo.',
  },
  {
    id: '2',
    date: '2022-08-30 00:00',
    name: 'Victor',
    content:
      'Fiz um acordo com a Recovery de uma dívida antiga que eu tinha em um banco. Consegui um bom desconto e meu nome sumiu do SPC!',
  },
]
